import { render } from "./IndexView2.vue?vue&type=template&id=0c8730aa&ts=true"
import script from "./IndexView2.vue?vue&type=script&lang=ts"
export * from "./IndexView2.vue?vue&type=script&lang=ts"

import "./IndexView2.vue?vue&type=style&index=0&id=0c8730aa&lang=css"
import "./IndexView2.vue?vue&type=style&index=1&id=0c8730aa&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__